const GENIUS_TYPE_MAP = [
    { key: 'wg', level: 'genius', customKey: 'genius' },
    { key: 'wc', level: 'competency', customKey: 'competency' },
    { key: 'wf', level: 'frustration', customKey: 'frustration' }
];

export const getReportData = (params) => {
    const {token = ''} = params;
    const data = parseToken(token);

    if(Date.now() > Number(data.exp) * 1000){
        throw new Error(`Token is expired`);
    }

    const extraData = {
        customResults: {},
        results: {
            genii: []
        }
    }

    GENIUS_TYPE_MAP.forEach(({ key, level, customKey }) => {
        extraData.customResults[`${customKey}1`] = data.results[`${key}1`];
        extraData.customResults[`${customKey}2`] = data.results[`${key}2`];

        extraData.results.genii.push(
            { label: data.results[`${key}1`], level },
            { label: data.results[`${key}2`], level }
        );
    });

    return {...data, ...extraData};
};

const parseToken = (token) => {
    try{
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }
    catch (error) {
        console.log(`Error while validating wg report token`, error);
        return null;
    }
}

export default {
    getReportData,
}